module.exports = __webpack_public_path__ + "static/media/alert_light.e5df70dd.svg";